import type { CSSProperties } from "react";

/**
 * Izgled odeljaka strane proizvoda: naslov odeljka, pločica sa natpisom i vrednošću, čip i okvir sa tekstom. Deli ih
 * tehnički list i stanje u magacinu, da strana izgleda kao jedna celina i da ne odstupe kad se jedan od njih menja.
 */
export const sectionTitle: CSSProperties = {
  fontSize: 11, letterSpacing: 0.8, textTransform: "uppercase", color: "var(--brand-primary)",
  fontWeight: 700, margin: "22px 0 10px", paddingBottom: 6, borderBottom: "2px solid var(--brand-primary-50)",
};

export const tiles: CSSProperties = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: 8 };
export const tile: CSSProperties = { background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--r-sm)", padding: 10 };
export const tileK: CSSProperties = { fontSize: 9.5, letterSpacing: 0.4, textTransform: "uppercase", color: "var(--ink-4)" };
export const tileV: CSSProperties = { fontSize: 13, fontWeight: 600, marginTop: 3, color: "var(--ink)" };

export const chips: CSSProperties = { display: "flex", flexWrap: "wrap", gap: 8 };
export const chip: CSSProperties = {
  fontSize: 12, color: "var(--brand-ink)", background: "var(--brand-primary-50)",
  border: "1px solid var(--border)", padding: "5px 12px", borderRadius: 999,
};

export const pane: CSSProperties = { background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--r-sm)", padding: "12px 14px", fontSize: 12.5, color: "var(--ink-2)" };
